import { Toolbar, Typography, Box, Stack, Divider, Paper } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import ChipRadioGroup from "../../../components/common/RadioChip/RadioChip";
import DropDown, {
  DropdownOptions,
} from "../../../components/common/Dropdown/Dropdown";
import { LoadingButton } from "@mui/lab";
import { Download1096SummaryType } from "../../../types/genericType";
import useFileDownloader from "../../../hooks/useFileDownloader";
import { apiEndPoints } from "../../../variables/apiEndpoints";
import CustomSnackbar from "../../../components/common/Snackbar/CustomSnackbar";

const Form1096 = () => {
  const [format, setFormat] = useState("PDF");
  const [isLoading, setIsLoading] = useState(false);
  const [year, setYear] = useState("");
  const { downloadFile } = useFileDownloader();
  const [onSuccess, setOnSuccess] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");

  const getFileExtension = (format: string) => {
    switch (format) {
      case 'Excel':
        return '.xls';
      case 'PDF':
        return '.pdf';
      default:
        return '';
    }
  };

  const currentYear = new Date().getFullYear();

  const yearOptions: DropdownOptions[] = Array.from(
    { length: currentYear - 1970 + 1 },
    (_, index) => currentYear - index
  ).map((year) => ({
    label: year.toString(),
    value: year.toString(),
  }));

  useEffect(() => {
    yearOptions.length > 0 && year === "" && setYear(yearOptions[0].value);
  }, [yearOptions]);

  const handleDownload = useCallback(async () => {
    setIsLoading(true);
    let body: Download1096SummaryType = {
      year: parseInt(year),
      format: format,
    };

    const result = await downloadFile({
      url: `/${apiEndPoints.downloadForm1096}`,
      method: "post",
      fileName: `form1096${getFileExtension(format)}`,
      data: body,
    });
    setIsLoading(false);
    if (!result.success) {
      setSnackbarMsg(result.errorMessage || "Error downloading file");
      setOnSuccess(true);
    }
  }, [downloadFile]);

  return (
    <>
      <Toolbar
        sx={{
          justifyContent: "space-between",
          margin: "0px 15px",
        }}
      >
        <Typography className="profile-title">Form 1096</Typography>
      </Toolbar>
      <Paper className="container pd-20">
        <Stack spacing={3}>
          <Typography className="title">Download Form 1096</Typography>
          <DropDown
            val={year}
            setVal={setYear}
            options={yearOptions}
            label="Year"
            width="93px"
            maxWidthOption="93px"
            minWidthOption="93px"
          />
          <Divider className="divider" />
          <Box className="actions">
            <ChipRadioGroup
              label="Format"
              value={format}
              setValue={setFormat}
              options={["PDF", "Excel"]}
            />
            <LoadingButton
              variant="contained"
              size="small"
              className="submit-btn"
              onClick={handleDownload}
              loading={isLoading}
            >
              Download
            </LoadingButton>
          </Box>
        </Stack>
        <CustomSnackbar
          open={onSuccess}
          message={snackbarMsg}
          setOpen={setOnSuccess}
        />
        <Divider />
      </Paper>
    </>
  );
};

export default Form1096;
